module.exports = __webpack_public_path__ + "img/xmasParty2.43fafae3.jpg";